import { Injectable, EventEmitter, Output, isDevMode } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Router, CanActivate } from '@angular/router';
import { Data } from './DataService';
import { Observable } from 'rxjs';
import { map } from "rxjs/operators";
import { Http } from '@angular/http';
import { environment } from 'src/environments/environment';
import { KeyconfigInitService } from './init/keyconfig-init.service';

export var errorMap;
export var testbase;


@Injectable({
  providedIn: 'root'
})

export class ProvidehttpService implements CanActivate {

  baseURL = '';
  restURL: '';
  defaultContext: string = '';
  showMenu = false;
  displaySide = false;
  ActiveTab = 'ServiceReqForm';
  showDraft = true;
  navBarMessage = '';
  currentLanguage;
  sessionValid = true;
  loggedIn = false;
  tfaapplet: any;
  tfaMessage: any;
  finalURL;
  oeLoggedIn = false;

  socketConnected: boolean = false;

  isLoggedIn(): boolean {
    return this.loggedIn && this.sessionValid;
  }

  canActivate() {
    if (this.isLoggedIn()) {
      return true;
    } else {
      this.sessionValid = false;
      this.data.formGenericData = "FLI008";
      this.router.navigate(["/logout"]);
      return false;
    }
  }

  constructor(private httpClient: HttpClient, private spinnerService: Ng4LoadingSpinnerService, private router: Router, private data: Data, private http: Http, private configInitService: KeyconfigInitService) {
    this.getJSON().subscribe(data => {
      errorMap = data['ErrorCodes'];
    }
      , error => { });
    this.configInitService.load().subscribe(data => {
      this.baseURL = data['baseURL'];
      this.defaultContext = data['defaultContext'];
      this.restURL = data['baseURL'];
    });
  }

  submitLoginForm(formCode, csrf, value) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token',
    });

    if (csrf) {
      headers = headers.set('_CSRF', csrf);
    }

    let httpOptions = {
      headers: headers,
      withCredentials: true
    };
    let json = {};
    json['MESSAGE'] = JSON.stringify(value);
    return this.httpClient.post<String>(this.restURL + "Auth/SSGW/" + formCode + "/SUBMIT", json, httpOptions);
  }

  resetLoginForm(formCode) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token',
    });

    let httpOptions = {
      headers: headers,
      withCredentials: true
    };

    const URL = this.restURL + 'Auth/SSGW/' + formCode + '/RESET';
    return this.httpClient.post(URL, '', httpOptions);
  }

  getElogoutAuthData() {
    this.loggedIn = false;
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token',
    });

    let httpOptions = {
      headers: headers,
      withCredentials: true
    };
    let json = {};
    let value = JSON.stringify(json);
    return this.httpClient.post<String>(this.restURL + "Auth/SSGW/ELOGOUT/SUBMIT", value, httpOptions);
  }

  domainObjectValidation(doURL, filterJSON, fieldValue, dependentValues, doServerUrl) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token',
    });
    // let httpOpts = { headers, withCredentials: true };
    let httpOpts = { headers };
    // var url = this.restURL.substring(0, this.restURL.length - 1)+'/publisher' + doURL;

    var url = this.baseURL + ((doServerUrl == undefined) ? this.defaultContext : doServerUrl) + doURL

    url = url.replace(url.substring(url.indexOf('{'), url.indexOf('}') + 1), fieldValue);

    var queryParam = "";
    dependentValues.forEach(
      (dep, key) => {
        if (dep.paramType == undefined || dep.paramType == 'PathParam') {
          url = url.replace('{' + key + '}', dep.value ? dep.value : '');
        } else if (dep.paramType == 'QueryParam') {
          queryParam += key + "=" + dep.value + "&";
        }
      }
    );

    if (queryParam.length > 0) {
      url += '?' + queryParam.substring(0, queryParam.length - 1);
    }
    url += 'criteriaDetails' + JSON.stringify(filterJSON);
    // console.log('url'+url);

    return this.httpClient.get(encodeURI(url), httpOpts);
  }

  loadLookup(doURL, dependentValues, pageNo: number, searchTerm: string, count: number, doServerUrl, filterCriteriaJSON, searchById: boolean = false) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token',
    });
    // let httpOpts = { headers, withCredentials: true };
    let httpOpts = { headers };

    // var url = this.restURL.substring(0, this.restURL.length - 1)+'/publisher' + doURL;

    var url = this.baseURL + ((doServerUrl == undefined) ? this.defaultContext : doServerUrl) + doURL

    url = url.replace(url.substring(url.indexOf('{') - 1, url.indexOf('}') + 1), "");

    var queryParam = "";
    dependentValues.forEach(
      (dep, key) => {
        if (dep.paramType == undefined || dep.paramType == 'PathParam') {
          url = url.replace('{' + key + '}', dep.value ? dep.value : '');
        } else if (dep.paramType == 'QueryParam') {
          queryParam += key + "=" + dep.value + "&";
          // queryParam += key + "=S01"+"&";

        }
      }
    );
    // console.log('url'+url)
    url += "?lookup=1";
    if (queryParam.length > 0) {
      url += '&' + queryParam.substring(0, queryParam.length - 1);
    }

    var criteriaDetails = {};
    if (searchTerm) {
      let filter = [];
      let filterOption = {};
      filterOption['columnName'] = (searchById ? 'id' : 'text');
      filterOption['columnType'] = 'string';
      filterOption['conditions'] = { searchText: searchTerm, searchType: (searchById ? 'equals' : 'Contains') };
      filter.push(filterOption);
      criteriaDetails['FilterCriteria'] = filter;
    }
    if (count > 0) {
      criteriaDetails['Count'] = count;
      criteriaDetails['Offset'] = (pageNo * count) + 1;
      url += "&criteriaDetails=" + JSON.stringify(criteriaDetails);
    }

    // if (count > 0) {

    //   if(filterCriteriaJSON!=null&&filterCriteriaJSON!=undefined){
    //     var length=filterCriteriaJSON['FilterCriteria'].length+1;
    //    let  filterExpression="("+filterCriteriaJSON['FilterExpression']+")"+"AND"+"(C"+length+")";
    //    filterCriteriaJSON['FilterExpression']=filterExpression;
    //       url += "&criteriaDetails="+JSON.stringify(filterCriteriaJSON);
    //   }else
    //   {
    //      criteriaDetails['Count'] = count;
    //      criteriaDetails['Offset'] = (pageNo * count) + 1;
    //   }
    // }



    return this.httpClient.get(encodeURI(url), httpOpts);
  }

  getContextPathValue(contextPath: string, jsonObj: {}) {
    if (contextPath == undefined || contextPath == "" || jsonObj == undefined) {
      return jsonObj;
    }
    var keys = contextPath.split(".");
    var value = jsonObj;
    for (var i = 0; i < keys.length; i++) {
      value = value[keys[i]];
    }
    return value;
  }

  async onSubmit(formCode, apiGatewayCode, serviceCode, formData, csrf): Promise<JSON> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token',
    });

    if (csrf) {
      headers = headers.set('_CSRF', csrf);
    }

    let httpOptions = {
      headers: headers,
      withCredentials: true
    };
    const URL = this.restURL + 'form/' + apiGatewayCode + '/' + formCode + '/' + serviceCode + '/urlaction/SUBMIT';

    let response = await this.httpClient.post(URL, formData, httpOptions).toPromise();
    let res = JSON.parse(JSON.stringify(response));

    return res;
  }

  showSpinner() {
    this.spinnerService.show();
  }

  hideSpinner() {
    this.spinnerService.hide();
  }

  getMenu() {
    const httpOpts = {
      headers: new HttpHeaders({
        //'ServiceCode':'MENU'
      }),
      withCredentials: true
    };
    return this.httpClient.get(this.restURL + 'internal/SSGW/EHOME/MENU', httpOpts);
  }

  mapToJson(inputMap) {
    let json = {}

    if (inputMap) {
      var iterator1 = Array.from(inputMap.keys());

      for (var key of iterator1) {
        var value = inputMap.get(key);
        if (value != undefined) {
          let arry = (<any>key).split(".");
          let arryLength = arry.length;
          let jsonObj = json;
          for (let i = 0; i < arryLength; i++) {
            if (i == arryLength - 1) {
              jsonObj[arry[i]] = value;
            }
            else {
              if (!jsonObj[arry[i]]) {
                jsonObj[arry[i]] = {};
              }
              jsonObj = jsonObj[arry[i]];
            }
          }
        }
      }
    }

    return json;
  }

  UnAuthorizationfetchApi(url: string, method: 'GET' | 'POST' | 'PUT' | 'DELETE', inputMap: Map<string, any>) {
    var json = this.mapToJson(inputMap);
    let headers = {
      'Content-Type': 'application/json',
      'App-Type': "FO",
      // 'Authorization': 'my-auth-token',
    };
    for (let key in json['HeaderParam']) {
      var value = json['HeaderParam'][key];
      if (value) {
        headers[key] = value;
      }
    }
    // let httpOpts = { headers: new HttpHeaders(headers) };
    let httpOpts: {
      headers: HttpHeaders,
      observe: any,
      //withCredentials:boolean
    } = {
      headers: new HttpHeaders(headers),
      observe: "response",
      //  withCredentials:true
    };

    for (let key in json['PathParam']) {
      var value = json['PathParam'][key];
      url = url.replace('{' + key + '}', value ? value : '');
    }
    // url = this.restURL.substring(0, this.restURL.length - 1) + url;    
    url = this.baseURL /*+ '/olive' */ + url;
    if (json['QueryParam']) {
      url += '?';
      for (let key in json['QueryParam']) {
        var value = json['QueryParam'][key];
        if (value) {
          if ((typeof value) != 'string') {
            value = JSON.stringify(value)
          }
          url += key + "=" + value + "&";
        }
      }
      url = url.substring(0, url.length - 1);
    }

    url = encodeURI(url);

    if (method == 'GET') {
      return this.httpClient.get(url, httpOpts);
    } else if (method == 'POST') {
      return this.httpClient.post<String>(url, JSON.stringify(json['Body']), httpOpts);
    } else if (method == 'PUT') {
      return this.httpClient.put<String>(url, JSON.stringify(json['Body']), httpOpts);
    } else if (method == 'DELETE') {
      return this.httpClient.delete(url, httpOpts);
    }
  }

  fetchApi(url: string, method: 'GET' | 'POST' | 'PUT' | 'DELETE', inputMap: Map<string, any>, serverUrl: string = undefined) {
    var json = this.mapToJson(inputMap);
    let headers = {
      'Content-Type': 'application/json',
      'App-Type': "FO",
      //'authorization': 'Bearer '+sessionStorage.getItem('access_token')
    };
    for (let key in json['HeaderParam']) {
      var value = json['HeaderParam'][key];
      if (value) {
        headers[key] = value;
      }
    }

    let httpOpts: {
      headers: HttpHeaders,
      observe: any,
      // withCredentials:boolean
    } = {
      headers: new HttpHeaders(headers),
      observe: "response",
      //  withCredentials:true
    };

    for (let key in json['PathParam']) {
      var value = json['PathParam'][key];
      url = url.replace('{' + key + '}', value ? value : '');
    }

    // url = this.restURL.substring(0, this.restURL.length - 1)+'/publisher' + url;

    url = this.baseURL + ((serverUrl == undefined) ? this.defaultContext : serverUrl) + url;

    if (json['QueryParam']) {
      url += '?';
      for (let key in json['QueryParam']) {
        var value = json['QueryParam'][key];
        if (value) {
          if ((typeof value) != 'string') {
            value = JSON.stringify(value);
          }
          url += key + "=" + value + "&";
        }
      }
      url = url.substring(0, url.length - 1);
    }

    url = encodeURI(url);

    if (method == 'GET') {
      return this.httpClient.get(url, httpOpts);
    } else if (method == 'POST') {
      return this.httpClient.post(url, JSON.stringify(json['Body']), httpOpts);
    } else if (method == 'PUT') {
      return this.httpClient.put(url, JSON.stringify(json['Body']), httpOpts);
    } else if (method == 'DELETE') {
      return this.httpClient.delete(url, httpOpts);
    }
  }

  checkForSession(response) {
    //   //var stringArray = ["SS00", "SS001", "SS002", "SS003", "SS004", "SS005", "SS006", "SS007", "SS008", "SS009", "SS0010", "SS0011"];
    //   var stringArray = ["FLI000", "FLI001", "FLI002", "FLI003", "FLI004", "FLI005", "FLI006", "FLI007", "FLI008", "FLI009", "FLI010", "FLI011", "FLI012", "FLI013"];
    //   if (response['Status'] == 'F') {
    //     if (stringArray.indexOf(response['error']) >= 0) {
    //       this.sessionValid = false;
    //       this.data.formGenericData = response['error'];
    //       this.router.navigate(['/logout']);
    //     }
    //   }
  }

  getFileName(cfsNumber) {
    const httpOpts = {
      headers: new HttpHeaders({
        //'Content-Type':  'application/json',
        //          'ServiceCode':'ALERTS'
      }),
      withCredentials: true
    };
    return this.httpClient.get('http://10.0.102.218:10593/olive/publisher/getfilename?invnumber=' + cfsNumber, httpOpts);
  }

  async resetForm(formCode, mode) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token',
    });

    let httpOptions = {
      headers: headers,
      withCredentials: true
    };

    let json = {};
    json['MODE'] = mode;

    this.showSpinner();
    const URL = this.restURL + 'form/SSGW/' + formCode + '/RESET' + '/urlaction/RESET';

    let response = await this.httpClient.post(URL, json, httpOptions).toPromise();
    this.hideSpinner();
    let res = JSON.parse(JSON.stringify(response));
    //this.checkForSession(res);
    return res;
  }

  saveAsDraft(formCode, apiGatewayCode, serviceCode, formData, RefNo, remarks) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token',
    });

    const httpOptions = {
      headers: headers,
      withCredentials: true
    };

    let Json = {
      Ref_No: RefNo,
      Data: formData,
      Remarks: remarks,
    };

    const URL = this.restURL + 'form/' + apiGatewayCode + '/' + formCode + '/' + serviceCode + '/urlaction/SAVEDRAFT';
    return this.httpClient.post(URL, Json, httpOptions);
  }

  loadAllDarfts(formCode, apiGatewayCode, serviceCode) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token',
    });

    const httpOptions = {
      headers: headers,
      withCredentials: true
    };
    const URL = this.restURL + 'form/' + apiGatewayCode + '/' + formCode + '/' + serviceCode + '/urlaction/LOADALLDRAFTS';
    return this.httpClient.post(URL, '', httpOptions);
  }

  loadDarft(formCode, apiGatewayCode, serviceCode, RefNo) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token',
    });

    let httpOptions = {
      headers: headers,
      withCredentials: true
    };

    let Json = {
      Ref_No: RefNo
    };
    const URL = this.restURL + 'form/' + apiGatewayCode + '/' + formCode + '/' + serviceCode + '/urlaction/LOADDRAFT';
    return this.httpClient.post(URL, Json, httpOptions);
  }
  deleteDarft(formCode, apiGatewayCode, serviceCode, RefNo) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token',
    });

    let httpOptions = {
      headers: headers,
      withCredentials: true
    };

    let Json = {
      Ref_No: RefNo
    };
    const URL = this.restURL + 'form/' + apiGatewayCode + '/' + formCode + '/' + serviceCode + '/urlaction/DELETEDRAFT';
    return this.httpClient.post<String>(URL, Json, httpOptions);
  }

  public getJSON(): Observable<any> {
    const url = window.location.origin + window.location.pathname + "assets/i18n/En.json";

    return this.http.get(url).pipe(map((res: any) => res.json()));
  }

  public translate(formCode, languageCode) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token',
    });

    let httpOptions = {
      headers: headers,
      withCredentials: true
    };
    return this.httpClient.get(this.restURL + 'internal/SSGW/' + formCode + '/TRANSLATE/LANGUAGE_CODE/' + languageCode, httpOptions);
  }

  downloadFile(cfsNumber, fileName = undefined) {
    var downloadAnchor = document.getElementById("fileDownloadAnchor");
    if (fileName) {
      downloadAnchor["download"] = fileName;
    }
    downloadAnchor["href"] = 'http://10.0.102.218:10593/olive/publisher/document/' + cfsNumber;
    downloadAnchor.click();
  }
}